<h1 ev-dialog-title data-testid="settings-title">{{ title() }}</h1>

<div ev-dialog-content #settingsScrollbar class="scrollable" data-testid="settings-container">

  <div class="settings-content">

    <!-- ==================== System Settings ==================== -->
    <app-modal-option-panel>
      <span panel-title>{{ languageService.languageJSON.SettingsDialog_SystemSettings }}</span>

      <div class="modal-option-panel__stack">
        <div class="modal-setting-row">
          <label>{{ languageService.languageJSON.SettingsDialog_Language }}</label>
          <mat-form-field class="modal-select-field setting-select">
            <mat-select disableRipple [(value)]="settingValueLanguage" data-testid="settings-language-select"
              panelClass="modal-select-panel" (selectionChange)="languageChanged()">
              @for (languageEl of Language(); track languageEl.code) {
                <mat-option [value]="languageEl.code" [attr.data-testid]="'settings-language-option-' + languageEl.code">
                  {{ languageEl.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </app-modal-option-panel>

    <!-- ==================== Addresses (Home / Work) ==================== -->
    @if (accountService.getIsAuthorized()) {
      <app-modal-option-panel>
        <div class="modal-option-panel__stack address-stack">

          <div class="address-block">
            <div class="address-header">
              <span class="address-title">{{ languageService.languageJSON.SettingsDialog_Home }}</span>
              @if (homeAddressText()) {
                <div class="address-functions">
                  <span class="manage-icon-btn" data-testid="settings-home-edit-btn" (click)="editAddress('home')">
                    <img class="manage-icon-svg" [src]="'/assets/icons/dark/ui/edit_icon.svg'" />
                  </span>
                  <span class="manage-icon-btn" data-testid="settings-home-remove-btn" (click)="removeAddress('home')">
                    <img class="manage-icon-svg" [src]="'/assets/icons/dark/ui/delete_icon.svg'" />
                  </span>
                </div>
              }
            </div>
            <button type="button" class="address-pill" data-testid="settings-home-address-btn" (click)="editAddress('home')">
              <span [innerText]="homeAddressText() ? homeAddressText() : languageService.languageJSON.SettingsDialog_AddHomeAddress"></span>
            </button>
          </div>

          <div class="address-block">
            <div class="address-header">
              <span class="address-title">{{ languageService.languageJSON.SettingsDialog_Work }}</span>
              @if (workAddressText()) {
                <div class="address-functions">
                  <span class="manage-icon-btn" data-testid="settings-work-edit-btn" (click)="editAddress('work')">
                    <img class="manage-icon-svg" [src]="'/assets/icons/dark/ui/edit_icon.svg'" />
                  </span>
                  <span class="manage-icon-btn" data-testid="settings-work-remove-btn" (click)="removeAddress('work')">
                    <img class="manage-icon-svg" [src]="'/assets/icons/dark/ui/delete_icon.svg'" />
                  </span>
                </div>
              }
            </div>
            <button type="button" class="address-pill" data-testid="settings-work-address-btn" (click)="editAddress('work')">
              <span [innerText]="workAddressText() ? workAddressText() : languageService.languageJSON.SettingsDialog_AddWorkAddress"></span>
            </button>
          </div>

        </div>
      </app-modal-option-panel>
    }

    <!-- ==================== Navigation Settings ==================== -->
    <app-modal-option-panel>
      <span panel-title>{{ languageService.languageJSON.SettingsDialog_NavigationSettings }}</span>

      <div class="modal-option-panel__stack">
        <div class="modal-setting-row">
          <label>{{ languageService.languageJSON.SettingsDialog_VoiceGuidance }}</label>
          <app-ev-switch [offSvg]="'./assets/icons/default/settings/settings_switch_icon_off.svg'"
            [onSvg]="'./assets/icons/default/settings/settings_switch_icon_on.svg'"
            class="value-switch" [(value)]="settingValueVoiceGuidance" data-testid="settings-voice-guidance-switch"
            (valueChangeEvent)="switchParamsChanged()"></app-ev-switch>
        </div>
      </div>
    </app-modal-option-panel>

    <!-- ==================== Map Settings ==================== -->
    <app-modal-option-panel>
      <span panel-title>{{ languageService.languageJSON.SettingsDialog_MapSettings }}</span>

      <div class="modal-option-panel__stack">
        <div class="modal-setting-row">
          <label>{{ languageService.languageJSON.SettingsDialog_Theme }}</label>
          <app-ev-switch [offSvg]="'./assets/icons/default/settings/settings_switch_icon_skin_dark.svg'"
            [onSvg]="'./assets/icons/default/settings/settings_switch_icon_skin_light.svg'"
            class="value-switch" [(value)]="settingValueMapColors" data-testid="settings-theme-switch"
            (valueChangeEvent)="switchParamsChanged()"></app-ev-switch>
        </div>
        <div class="modal-setting-row">
          <label>{{ languageService.languageJSON.SettingsDialog_POIs }}</label>
          <app-ev-switch [offSvg]="'./assets/icons/default/settings/settings_switch_icon_off.svg'"
            [onSvg]="'./assets/icons/default/settings/settings_switch_icon_on.svg'"
            class="value-switch" [(value)]="settingValuePOIs" data-testid="settings-pois-switch"
            (valueChangeEvent)="switchParamsChanged()"></app-ev-switch>
        </div>
      </div>
    </app-modal-option-panel>

    <!-- ==================== Unit Settings ==================== -->
    <app-modal-option-panel>
      <span panel-title>{{ languageService.languageJSON.SettingsDialog_UnitsSettings }}</span>

      <div class="modal-option-panel__stack">
        <div class="modal-setting-row">
          <label>{{ languageService.languageJSON.Global_Distance }}</label>
          <app-ev-switch [offSvg]="'./assets/icons/default/settings/settings_switch_icon_distance_imperial.svg'"
            [onSvg]="'./assets/icons/default/settings/settings_switch_icon_distance_metric.svg'" 
           class="value-switch" [(value)]="settingValueDistance" data-testid="settings-distance-switch"
            (valueChangeEvent)="switchParamsChanged()"></app-ev-switch>
        </div>
        <div class="modal-setting-row">
          <label>{{ languageService.languageJSON.SettingsDialog_Temperature }}</label>
          <app-ev-switch [offSvg]="'./assets/icons/default/settings/settings_switch_icon_temperature_imperial.svg'"
            [onSvg]="'./assets/icons/default/settings/settings_switch_icon_temperature_metric.svg'"
            class="value-switch" [(value)]="settingValueTemperature" data-testid="settings-temperature-switch"
            (valueChangeEvent)="switchParamsChanged()"></app-ev-switch>
        </div>
        <div class="modal-setting-row">
          <label>{{ languageService.languageJSON.SettingsDialog_Speed }}</label>
          <app-ev-switch [offSvg]="'./assets/icons/default/settings/settings_switch_icon_speed_imperial.svg'"
            [onSvg]="'./assets/icons/default/settings/settings_switch_icon_speed_metric.svg'"
            class="value-switch" [(value)]="settingValueSpeed" data-testid="settings-speed-switch"
            (valueChangeEvent)="switchParamsChanged()"></app-ev-switch>
        </div>
        <div class="modal-setting-row">
          <label>{{ languageService.languageJSON.SettingsDialog_Pressure }}</label>
          <app-ev-switch [offSvg]="'./assets/icons/default/settings/settings_switch_icon_pressure_imperial.svg'"
            [onSvg]="'./assets/icons/default/settings/settings_switch_icon_pressure_metric.svg'"
            class="value-switch" [(value)]="settingValuePressure" data-testid="settings-pressure-switch"
            (valueChangeEvent)="switchParamsChanged()"></app-ev-switch>
        </div>
      </div>
    </app-modal-option-panel>

    @if (settingsError()) {
      <div class="error-outer">
        <h5 class="error-text">{{ languageService.languageJSON.Global_SomethingWentWrong }}</h5>
      </div>
    }

  </div>
</div>

@if (dialogContentIsLoading()) {
  <div class="dialog-loader-outer">
    <app-ev-loader></app-ev-loader>
  </div>
}

<div ev-dialog-actions>
  <button class="ev-button primary" name="ok_button" mat-button data-testid="settings-ok-btn" (click)="dialogClose()">
    {{ languageService.languageJSON.Global_Ok }}
  </button>
  <button class="ev-button" name="cancel_button" mat-button data-testid="settings-cancel-btn" (click)="dialogRef.close()">
    {{ languageService.languageJSON.Global_Cancel }}
  </button>
</div>
